/* eslint-disable no-console */
import { useSelector } from 'react-redux';
import { catchErr, queryParams } from '../../../libs/HelperContent';
import { existFolder } from '../../actions/media_actions';

const useCheckExistFolder = () =>
{
	const userData = useSelector((state:any) => state?.mysession?.session);

	const query:any = {
		uid        : userData?.userId,
		comid      : userData?.companyId,
		empRole    : userData?.empRole,
		role       : userData?.role,
		actionType : 'create'

	};
	const checkFolderName = async (nameArr:any, parentId:any, type:number, ownerId = '') =>
	{
		const body:any = {
			name   : nameArr,
			parent : parentId,
			type   : Number(type)

		};

		if (ownerId) query.ownerId = ownerId;

		try
		{
			const res = await existFolder(query, body);

			return res;
		}
		catch (err)
		{
			console.log(err, '-********');
			catchErr(err);
		}
	};

	return checkFolderName;
};

export default useCheckExistFolder;